import { useState, useEffect, useCallback } from "react";
import apiService from "../services/api.service";
import { useAuth } from "./useAuth";

export const useDashboard = () => {
const { hasAdminAccess } = useAuth();
const [stats, setStats] = useState(null);
const [chartData, setChartData] = useState(null);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);

  const fetchDashboardData = useCallback(async () => {
    if (!hasAdminAccess) {
      setLoading(false);
      setError("Acceso no autorizado");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Llama al endpoint de backend consolidado (¡Rápido!)
      const data = await apiService.getDashboardStats();

      // === Mapeo de datos para el estado del componente ===
      // Los KPIs van directamente a 'stats'
      setStats({
        totalReclamos: data.totalReclamos,
        reclamosActivos: data.reclamosActivos,
        usuariosRegistrados: data.usuariosRegistrados,
        
        // Nuevos KPIs clave
        tiempoPromedioResolucionDias: data.tiempoPromedioResolucionDias,
        promedioCalificacionSolucion: data.promedioCalificacionSolucion,
        tasaConfiabilidadPromedio: data.tasaConfiabilidadPromedio,
        reclamosConSuscripcion: data.reclamosConSuscripcion,
      });

      // Los datos de gráficos van a 'chartData'
      setChartData({
        categorias: data.categorias,
        estados: data.estados, // Nuevo: Distribución por Estado
        actividad: data.actividad,
        tendencia: data.tendencia,
        denunciasRecientes: data.denunciasRecientes,
      });

    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError(err.message || "Error al cargar los datos del dashboard.");
    } finally {
      setLoading(false);
    }
  }, [hasAdminAccess]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return {
    stats,
    chartData,
    loading,
    error,
    fetchDashboardData,
  };
};